import React, { useState, useEffect } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

import { useDispatch, useSelector } from "react-redux";
import { reviewClaimAction } from "state/actions/claimActions";

const ReviewClaimDrawer = ({ isOpen, onClose, claim, onReviewed, onError }) => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.claims || {});

    const [formData, setFormData] = useState({
        admin_note: "",
        payout_amount: "",
        status: "Approved", // default value
    });

    useEffect(() => {
        if (claim) {
            setFormData({
                admin_note: claim.admin_note || "",
                payout_amount: claim.payout_amount ?? "",
                status: claim.status || "Submitted",
            });
        }
    }, [claim]);

    if (!claim) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const payload = {
            admin_note: formData.admin_note,
            payout_amount: Number(formData.payout_amount),
            status: formData.status, // comes from input now
        };

        const res = await dispatch(reviewClaimAction(claim.claim_id, payload));

        if (res.success) {
            onClose();
            onReviewed?.(formData.status);
        } else {
            onError?.(res.error);
        }
    };

    return (
        <ReusableDrawer
            isOpen={isOpen}
            onClose={onClose}
            headerContent={<h2>Review Claim</h2>}
            bodyContent={
                <Stack spacing={4}>
                    <ReusableInput
                        label="Status"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        type="select"
                        options={[
                            { label: "Submitted", value: "Submitted" },
                            { label: "Under review", value: "Under review" },
                            { label: "Approved", value: "Approved" },
                            { label: "Rejected", value: "Rejected" },
                            { label: "Paid", value: "Paid" },
                            { label: "Canceled", value: "Canceled" },
                        ]}
                    />

                    <ReusableInput
                        label="Admin Note"
                        name="admin_note"
                        value={formData.admin_note}
                        onChange={handleChange}
                        placeholder="Enter admin note"
                    />

                    <ReusableInput
                        label="Payout Amount"
                        name="payout_amount"
                        type="number"
                        value={formData.payout_amount}
                        onChange={handleChange}
                        placeholder="Enter payout amount"
                    />
                </Stack>
            }
            footerContent={
                <Stack direction="row" spacing={4} justifyContent="flex-end">
                    <GradientButton onClick={onClose} width="100px" height="40px">
                        Cancel
                    </GradientButton>

                    <GradientButton
                        onClick={handleSubmit}
                        width="100px"
                        height="40px"
                        isDisabled={loading}
                    >
                        Save
                    </GradientButton>
                </Stack>
            }
            size="lg"
        />
    );
};

export default ReviewClaimDrawer;